export const isHtmlUploadRecord = (fileName = '', contentType = '') => {
  const normalizedFileName = fileName.toLowerCase();
  const normalizedContentType = contentType.toLowerCase();
  return normalizedFileName.endsWith('.html')
    || normalizedFileName.endsWith('.htm')
    || normalizedContentType.startsWith('text/html');
};

export const isCustomDomainUploadRecord = (fileName = '', contentType = '') => {
  return isHtmlUploadRecord(fileName, contentType)
    || fileName.toLowerCase().endsWith('.sh');
};
